import * as R from 'ramda';
import { createReducer } from 'redux-act';
// helpers/constants
import * as G from '../../helpers';
// components modal
import * as A from './actions.js';
//////////////////////////////////////////////////

const initialState = {
  modal: [],
  isOpened: false,
};

const openModal = (state, payload) => ({
  isOpened: true,
  modal: R.append(payload, state.modal),
});

const closeModal = (state) => ({
  modal: R.init(state.modal),
  isOpened: G.isNotEmpty(R.init(state.modal)),
});

const closeAllModals = () => initialState;

const closeModalById = (state, modalId) => {
  const modal = state.modal.filter((item) => item.id !== modalId);

  if (modal.length === state.modal.length) return state;

  return { modal, isOpened: G.isNotEmpty(modal) };
};

export default createReducer({
  [A.openModal]: openModal,
  [A.closeModal]: closeModal,
  [A.closeModalById]: closeModalById,
  [A.closeAllModals]: closeAllModals,
}, initialState);
